module.exports = __webpack_public_path__ + "img/comp_turbine-hs.4fe14163.png";